import React from 'react';

const DeactivateTeamIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-deactivate-team" />
    </div>
  );
};

export default DeactivateTeamIcon;
